import React from "react";
import {
  FaBullseye,
  FaLightbulb,
} from "react-icons/fa";

import { motion } from "framer-motion";

export default function VisionMission() {
  const cards = [
    {
      title: "VISION",
      icon: <FaBullseye />,
      paragraphs: [
        "Dreaming matters- to our families, our communities, the world and especially to ourselves.",

        "Dreaming is an inalienable right of every parent and student and education is the most powerful medium through which ‘Dreams’ can be changed into reality.",

        "We respect their dreams by providing the right environment, wherein the students ‘Dare’ to spread their wings of learning and ‘Do’ their best to achieve the unassailable heights.",
      ],
    },

    {
      title: "MISSION",
      icon: <FaLightbulb />,
      paragraphs: [
        "The school is committed to provide a framework wherein the students receive substantial education, hone their talents and unleash the hidden potential within themselves to scale the phenomenal heights.",

        "We value and appreciate diverse dimensions of each child- intellectual, social, emotional, aesthetic, physical and spiritual.",

        "Thus keeping in mind the diversity among the students, we create a resplendent world where all the students are appreciated and encouraged according to their interests.",

        "We formulate new ventures where our students work progressively to soar high and become global citizens.",
      ],
    },
  ];

  return (
    <section className="relative bg-[#f7f9fc] overflow-hidden py-16">

      <div className="max-w-[1250px] mx-auto px-6">

        {/* ================= HEADING ================= */}
        <div className="text-center mb-14">

          <p className="uppercase tracking-[7px] text-[#d4af37] font-bold text-sm">
            Cambridge International School
          </p>

          <h2 className="text-4xl md:text-6xl font-black text-[#07294d] mt-4">
            Vision <span className="text-[#d4af37]">&</span> Mission
          </h2>

        </div>


        {/* ================= CARDS ================= */}
        <div className="grid lg:grid-cols-2 gap-8">

          {cards.map((item, index) => (

            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.6,
                delay: index * 0.15,
              }}
              viewport={{ once: true }}
              whileHover={{ y: -8 }}
              className="relative bg-white rounded-[30px] p-8 shadow-xl border border-gray-100 overflow-hidden"
            >

              {/* Gold Line */}
              <div className="absolute top-0 left-0 w-full h-1 bg-[#d4af37]"></div>


              {/* ================= TITLE ================= */}
              <div className="flex items-center gap-5 mb-6">

                <div className="w-16 h-16 rounded-2xl bg-[#07294d] text-[#d4af37] flex items-center justify-center text-3xl shrink-0">
                  {item.icon}
                </div>

                <h3 className="text-3xl font-black text-[#07294d]">
                  {item.title}
                </h3>

              </div>


              {/* ================= PARAGRAPHS ================= */}
              <div className="space-y-5">

                {item.paragraphs.map((paragraph, i) => (

                  <p
                    key={i}
                    className="text-gray-600 text-sm md:text-base leading-7"
                  >
                    {paragraph}
                  </p>

                ))}

              </div>

            </motion.div>

          ))}

        </div>

      </div>

    </section>
  );
}